import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import './components/scrollToHash.js';

document.addEventListener("DOMContentLoaded", async () => {
    // --- Scrollbar ---
    const scrollBarBoxEl = document.querySelectorAll(".jsScrollBar");
    if (scrollBarBoxEl.length > 0) {
        const { renderScrollBar } = await import("./components/scrollbar.js");
        renderScrollBar(scrollBarBoxEl);
    }

    // --- Custom Select ---
    const selectEl = document.querySelectorAll(".jsSelect");
    if (selectEl.length > 0) {
        const { renderSelect } = await import("./components/select.js");
        renderSelect(selectEl);
    }

    // --- Anchor Smooth Scroll ---
    const anchorEl = document.querySelectorAll(".c-anchor-link a[href^='#']");
    if (anchorEl.length > 0 ) {
        const { enableAnchorScroll } = await import("./components/anchor.js");
        enableAnchorScroll({
            selector: ".c-anchor-link a[href^='#']",
            elFixedHeight: 114,
            stepSpace: 1,
            duration: 600,
            activeClass: "active",
        });
    }

    // --- Class Smooth Scroll, active background error (.e-txt-error) ---
    const classErrEl = document.querySelectorAll(".e-txt-error");
    if (classErrEl.length > 0) {
        const { scrollToClass } = await import("./components/scrollToClass.js");
        scrollToClass(".e-txt-error", {
            elFixedHeight: $('body').hasClass('fullPage')? 0 : 114,
            stepSpace: 1,
            duration: 1000,
        });
        const { activeErrorBackground } = await import("./components/activeErrorBackground.js");
        activeErrorBackground();
    }

    // --- Add/Remove/dragdrop ---
    const repeatGroupEl = document.querySelectorAll(".js-repeat-group, .jsItemGroup");
    if (repeatGroupEl.length > 0) {
        const { initRepeatable } = await import("./components/addRemove.js");
        initRepeatable();
    }

    // --- Add inner box ---
    const addBoxEl = document.querySelectorAll(".js-repeat-group");
    if (addBoxEl.length > 0) {
        const { initAddBoxLogic } = await import("./components/addBox.js");
        initAddBoxLogic();
    }    

    // --- Modal ---
    const modalBtns = document.querySelectorAll("[data-modal]");
    if (modalBtns.length > 0) {
        const { initModal } = await import("./components/modal.js");
        initModal();
    }

    // --- Image Upload & Crop ---
    const uploadModal = document.querySelector("#upload-modal");
    const uploadBtn = document.querySelector("[data-modal='upload-modal']");
    if (uploadModal && uploadBtn) {
        const { initCropperUpload } = await import("./components/uploadImage.js");
        initCropperUpload();
    }

    // --- Remove Icon (js-remove-item) ---
    const removeBtns = document.querySelectorAll(".js-remove-item, .js-remove-error");
    if (removeBtns.length > 0) {
        const { initIconRemove } = await import("./components/iconRemove.js");
        initIconRemove();
    }

    // --- accordion ---
    if (document.querySelector(".accordion")) {
        const { initAccordion } = await import("./components/accordion.js");
        initAccordion();
    }

    // --- anchor ---
    if (document.querySelector(".group-link")) {
        const { initHowto } = await import("./components/howto.js");
        initHowto();
    }
});